import { Badge, Col, Row, Tabs } from "antd"
import React, { useState } from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { QuestionCircleFilled } from "@ant-design/icons"
import ActiveRequests from "./ActiveRequests"
import useAdminActiveRequests from "../../../store/Admin/useAdminActiveRequests"
import ClosedRequests from "./ClosedRequests"

export default function RequestTabs() {
  const [currentActiveKey, setCurrentActiveKey] = useState(1)
  const { activeRequests, loading, activeRequestCount } = useAdminActiveRequests()

  const items = [
    {
      key: 1,
      label: (
        <Badge size="small" offset={[10, 0]} count={activeRequestCount}>
          Active Requests
        </Badge>
      ),
      children: (
        <ActiveRequests
          activeKey={currentActiveKey}
          activeReqLoading={loading}
          activeReq={activeRequests}
        />
      ),
    },

    {
      key: 2,
      label: "Closed Requests",
      children: <ClosedRequests activeKey={currentActiveKey} />,
    },
  ]

  const onChange = (key) => {
    setCurrentActiveKey(key)
  }

  return (
    <div style={{ padding: 15 }}>
      <Row>
        <Col span={24}>
          <PageHeader icon={<QuestionCircleFilled />} text="Admin Requests" />
        </Col>
        <Col span={24}>
          <Tabs defaultActiveKey={1} items={items} onChange={onChange} />
        </Col>
      </Row>
    </div>
  )
}
